import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function useUsersInOrg() {
  return useQuery({
    ...orpc.core.users.listInOrg.queryOptions(),
    staleTime: 5 * 60 * 1000,
  });
}
